import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Gallery
 */
const Gallery = (() => {
	/**
	 * Gallery
	 *
	 * @var { Object }
	 */
	const Selector = {
		GALLERY: '.gallery:not(.gallery-slider)',
		GALLERY_FANCYBOX: '.gallery-image [data-fancybox="gallery"]'
	};

	/**
	 * Gallery
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Gallery extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this._bindHandlers();
		}

		// Private

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			this.$element.find(Selector.GALLERY_FANCYBOX).fancybox({
				animationEffect: 'fade',
				animationDuration: 500
			});
		}
	}

	return Gallery._getElements(Selector.GALLERY, Gallery);
})();

export default Gallery;
